<mat-sidenav-container autosize>
    <mat-sidenav #sidenav mode="open" [fixedInViewport]="true" class="main-inspector">
        <!-- Mobile -->
        <div class="flex column mobile-sidenav flex-100">
            <ng-scrollbar>
                <div class="flex row mobile-sidenav-content">
                    <frog-workspace-list></frog-workspace-list>
                    <frog-stream-list class="flex align-items-start"></frog-stream-list>
                </div>
            </ng-scrollbar>
            <frog-site-toolbar></frog-site-toolbar>
        </div>
        <!-- Desktop -->
        <div class="height-container desktop">
            <ng-scrollbar [autoHeightDisabled]="true" [autoWidthDisabled]="true">
                <div>
                    <button mat-icon-button (click)="sidenav.close()">
                        <mat-icon>first_page</mat-icon>
                    </button>
                    <frog-inspector></frog-inspector>
                </div>
            </ng-scrollbar>
        </div>
    </mat-sidenav>

    <mat-sidenav-content>
        <div class="flex row height-container">
            <div class="desktop workspaces">
                <frog-workspace-list></frog-workspace-list>
            </div>
            <div class="flex column height-container">
                @if (siteConfig$ | async; as siteConfig) {
                    <div class="height-container">
                        <!-- Client Setup -->
                        @if (siteConfig.data.setup !== SetupState.Complete) {
                            <div>
                                <mat-toolbar>
                                    <mat-toolbar-row class="flex row black">
                                        <div class="toolbar-workspace">
                                            <a class="name">{{ siteConfig.displayName }}</a>
                                        </div>
                                    </mat-toolbar-row>
                                </mat-toolbar>
                                <frog-setup></frog-setup>
                            </div>
                        } @else {
                            <!-- Main View -->
                            @if (viewingAsset$ | async) {
                                <frog-viewer></frog-viewer>
                            }
                            <div class="height-container">
                                <frog-upload-drop></frog-upload-drop>
                                <frog-selection-toolbar></frog-selection-toolbar>
                                <!-- Mobile -->
                                <div class="mobile sticky">
                                    <mat-toolbar>
                                        <mat-toolbar-row class="flex row black">
                                            <button mat-icon-button (click)="toggleWorkspaces()">
                                                <mat-icon>menu</mat-icon>
                                            </button>
                                            @if (siteConfig$ | async; as siteConfig) {
                                                <div class="toolbar-workspace">
                                                    <a
                                                        [routerLink]="[
                                                            '/s',
                                                            siteConfig.data.primary_stream,
                                                        ]"
                                                        class="name"
                                                        >{{ siteConfig.data.name }}</a
                                                    >
                                                </div>
                                            }
                                            <span class="spacer"></span>
                                            <frog-upload-button></frog-upload-button>
                                            <button
                                                mat-icon-button
                                                matTooltip="Select Mode"
                                                (click)="selectMode()"
                                            >
                                                <mat-icon>highlight_alt</mat-icon>
                                            </button>
                                        </mat-toolbar-row>
                                        <mat-toolbar-row>
                                            <frog-search class="flex"></frog-search>
                                            <frog-filters-sheet-button></frog-filters-sheet-button>
                                        </mat-toolbar-row>
                                    </mat-toolbar>
                                </div>
                                <!-- Desktop -->
                                <div class="desktop nav-wrapper">
                                    <mat-toolbar>
                                        <!-- Top Toolbar -->
                                        <mat-toolbar-row
                                            class="flex row black justify-space-between"
                                        >
                                            @if (siteConfig$ | async; as siteConfig) {
                                                <div class="toolbar-workspace">
                                                    <a
                                                        [routerLink]="[
                                                            '/s',
                                                            siteConfig.data.primary_stream,
                                                        ]"
                                                        class="name"
                                                        >{{ siteConfig.data.name }}</a
                                                    >
                                                </div>
                                            }
                                            <div class="flex toolbar-search">
                                                <frog-search class="flex" #search></frog-search>
                                                <frog-filter-panel-button
                                                    [search]="search"
                                                ></frog-filter-panel-button>
                                            </div>
                                            <div class="flex toolbar-menu">
                                                <div class="flex align-end justify-end">
                                                    <frog-invite-users-button></frog-invite-users-button>
                                                    <frog-upload-button></frog-upload-button>
                                                    <frog-site-menu></frog-site-menu>
                                                </div>
                                            </div>
                                        </mat-toolbar-row>
                                        <!-- Streams and Filters Toolbar -->
                                        <mat-toolbar-row>
                                            <frog-stream-menu
                                                class="toolbar-streams"
                                            ></frog-stream-menu>
                                            <frog-filters class="toolbar-filters"></frog-filters>
                                            <div
                                                class="flex align-end justify-end selection-button"
                                            >
                                                <frog-add-review-button></frog-add-review-button>
                                                <button
                                                    mat-icon-button
                                                    matTooltip="Select Mode"
                                                    (click)="selectMode()"
                                                >
                                                    <mat-icon>highlight_alt</mat-icon>
                                                </button>
                                            </div>
                                        </mat-toolbar-row>
                                    </mat-toolbar>
                                </div>
                                <div class="list-wrapper">
                                    <frog-asset-list></frog-asset-list>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
